"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _emotion = require("emotion");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _find = _interopRequireDefault(require("lodash/find"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _attributeSelector = _interopRequireWildcard(require("@cimpress-technology/attribute-selector"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _lodash = require("lodash");

var _constants = _interopRequireDefault(require("./constants"));

var _commonUtils = require("./commonUtils");

var _services = require("./services");

var _V2Parser = require("./V2Parser");

var _attributeSelectorPricing = require("./attributeSelectorPricing");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  hr {\n    display: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var removeSeparator = (0, _emotion.css)(_templateObject());

var AttributesAggregator =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(AttributesAggregator, _PureComponent);

  function AttributesAggregator(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AttributesAggregator);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AttributesAggregator).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentDidMount", function () {
      var _this$withOutFamily = _this.withOutFamily(),
          initialAttributeConfigurations = _this$withOutFamily.initialAttributeConfigurations,
          sortedRuleSet = _this$withOutFamily.sortedRuleSet;

      _this.setState({
        initialAttributeConfigurations: initialAttributeConfigurations,
        sortedRuleSet: sortedRuleSet
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentDidUpdate", function (prevProps) {
      var _this$withOutFamily2 = _this.withOutFamily(),
          initialAttributeConfigurations = _this$withOutFamily2.initialAttributeConfigurations,
          sortedRuleSet = _this$withOutFamily2.sortedRuleSet;

      if (!(0, _lodash.isEqual)(initialAttributeConfigurations, _this.state.initialAttributeConfigurations)) {
        _this.setState({
          initialAttributeConfigurations: initialAttributeConfigurations
        });
      }

      if (!(0, _lodash.isEqual)(prevProps.family, _this.props.family)) {
        _this.setState({
          sortedRuleSet: sortedRuleSet
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setPivotAttributes", function (v2InitialSelections, pivotConfiguration) {
      var showSelectorPivotUI = _this.props.showSelectorPivotUI;

      if (!v2InitialSelections) {
        v2InitialSelections = {};
      }

      pivotConfiguration.forEach(function (attribute) {
        var key = attribute.key.toLowerCase();

        if (v2InitialSelections[key]) {
          delete v2InitialSelections[key];
          v2InitialSelections[key] = _objectSpread({
            isPivot: true
          }, v2InitialSelections[key], {
            isHidden: !showSelectorPivotUI,
            initialSelection: attribute.pivotValues
          });
        } else {
          v2InitialSelections[key] = {
            isPivot: true,
            isHidden: !showSelectorPivotUI,
            initialSelection: attribute.pivotValues
          };
        }
      });
      return v2InitialSelections;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeAttributeOrder", function (whiteList, pivotConfiguration) {
      if (whiteList) {
        if (Array.isArray(pivotConfiguration)) {
          pivotConfiguration.forEach(function (pivotedAttribute) {
            var index = whiteList.findIndex(function (attribute) {
              return attribute.attributeKey.toLowerCase() === pivotedAttribute.key.toLowerCase();
            });

            if (index > -1) {
              whiteList.push(whiteList.splice(index, 1)[0]);
            }
          });
        }

        var index = whiteList.findIndex(function (attribute) {
          return attribute.attributeKey.toLowerCase() === 'mcpsku';
        });

        if (index > 0) {
          whiteList = [whiteList[index]].concat((0, _toConsumableArray2["default"])(whiteList.splice(index, 1)));
        }
      }

      return whiteList;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updatePivotAttributes", function (pivotConfiguration) {
      pivotConfiguration.forEach(function (item) {
        if (_this.ref.current) {
          _this.ref.current.updateHiddenPivotAttribute(item.key, item.pivotValues);
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "withOutFamily", function () {
      var _this$props = _this.props,
          family = _this$props.family,
          productAttributeKeys = _this$props.productAttributeKeys,
          hiddenAttributes = _this$props.hiddenAttributes,
          selectedSkuInFamily = _this$props.selectedSkuInFamily,
          pivotConfiguration = _this$props.pivotConfiguration,
          initialAttributeSelections = _this$props.initialAttributeSelections,
          consumerType = _this$props.consumerType;

      if (!selectedSkuInFamily && family.sku && family.ruleSet) {
        var productAttributeKeysWithSku = (0, _toConsumableArray2["default"])(productAttributeKeys);
        productAttributeKeysWithSku.unshift(_constants["default"].MCPSKU); // Getting sorted list of whitelist so that McpSku will come on the top.

        var sortedRuleSet = (0, _cloneDeep["default"])(family.ruleSet);

        var sortedAttributesList = _this.changeAttributeOrder(sortedRuleSet.whiteList, pivotConfiguration);

        sortedRuleSet.whiteList = sortedAttributesList;
        var initialSelections = initialAttributeSelections ? (0, _cloneDeep["default"])(initialAttributeSelections) : {}; // Passing selected sku in initialAttributeSelections

        initialSelections.McpSku = family.sku;
        var v2Selections;

        if (consumerType === _constants["default"].ATTRIBUTESELECTORPRICING) {
          v2Selections = (0, _attributeSelectorPricing.convertToAttributeConfiguration)(initialSelections);
        } else {
          v2Selections = (0, _V2Parser.convertInitialSelections)(initialSelections, productAttributeKeys, sortedAttributesList, hiddenAttributes);
        }

        var country = v2Selections[_constants["default"].COUNTRY];

        if (country && country.initialSelection && !country.initialSelection.includes('(')) {
          country.initialSelection = (0, _services.getCountryName)(country.initialSelection);
        }

        var initialAttributeConfigurations = _this.setPivotAttributes(v2Selections, pivotConfiguration);

        return {
          initialAttributeConfigurations: initialAttributeConfigurations,
          sortedRuleSet: sortedRuleSet
        };
      }

      return {
        initialAttributeConfigurations: {},
        sortedRuleSet: {}
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderWithOutFamily", function () {
      var _this$props2 = _this.props,
          authToken = _this$props2.authToken,
          isPivot = _this$props2.isPivot,
          onChange = _this$props2.onChange,
          onChangePivotResponse = _this$props2.onChangePivotResponse,
          onError = _this$props2.onError,
          productAttributeKeys = _this$props2.productAttributeKeys;
      var _this$state = _this.state,
          initialAttributeConfigurations = _this$state.initialAttributeConfigurations,
          sortedRuleSet = _this$state.sortedRuleSet;
      var selections = {};

      if (initialAttributeConfigurations) {
        Object.keys(initialAttributeConfigurations).forEach(function (item) {
          if (initialAttributeConfigurations[item].isHidden === false || initialAttributeConfigurations[item].isPivot === true || (0, _commonUtils.areKeysSame)(item, _constants["default"].QUANTITY)) {
            selections[item] = _objectSpread({}, initialAttributeConfigurations[item]);
          } else {
            selections[item] = _objectSpread({}, initialAttributeConfigurations[item], {
              initialSelection: null
            });
          }
        });
      }

      if (!sortedRuleSet) {
        return _react["default"].createElement("div", null);
      }

      return _react["default"].createElement(_attributeSelector.CustomRequiredSelector, {
        ruleSet: sortedRuleSet,
        authToken: authToken,
        onChange: isPivot ? onChangePivotResponse : onChange,
        onReset: _this.props.onReset,
        attributeConfigurations: selections,
        isPivot: isPivot,
        ref: _this.ref,
        onError: onError,
        customRequiredAttributes: productAttributeKeys
      });
    });
    _this.ref = _react["default"].createRef();
    _this.state = {};
    return _this;
  }

  (0, _createClass2["default"])(AttributesAggregator, [{
    key: "renderWithFamily",
    value: function renderWithFamily(initialAttributeSelections) {
      var _this$props3 = this.props,
          family = _this$props3.family,
          productAttributeKeys = _this$props3.productAttributeKeys,
          hiddenAttributes = _this$props3.hiddenAttributes,
          authToken = _this$props3.authToken,
          selectedSkuInFamily = _this$props3.selectedSkuInFamily,
          attributeConfigurations = _this$props3.attributeConfigurations,
          onReset = _this$props3.onReset,
          consumerType = _this$props3.consumerType;
      var initialSelections = (0, _cloneDeep["default"])(initialAttributeSelections);
      var v2Selections;

      if (consumerType === _constants["default"].ATTRIBUTESELECTORPRICING) {
        v2Selections = (0, _cloneDeep["default"])(attributeConfigurations);
      } else {
        // TODO
        // I doubt we need this condition because if we are supporting family in Aggregator then it would be only for attribute selector.
        // Need to check comparison screen use case.
        v2Selections = (0, _V2Parser.convertInitialSelections)(initialSelections, productAttributeKeys, family.ruleSet ? family.ruleSet.whiteList : [], hiddenAttributes);
      }

      if (selectedSkuInFamily) {
        v2Selections[_constants["default"].MCPSKU] = {
          initialSelection: selectedSkuInFamily
        };
      } // For marketplace use case we can't mark non-product attribuites as required on ui, so narking required as false
      // and forcing isHidden as false so user can see them on ui.


      (0, _forEach["default"])((0, _commonUtils.getNonProductAttributes)(family.ruleSet.whiteList), function (nonProductAttribute) {
        (0, _find["default"])(family.ruleSet.whiteList, function (attributeToChange) {
          if (nonProductAttribute.attributeKey === attributeToChange.attributeKey) {
            attributeToChange.required = false;
            v2Selections[attributeToChange.attributeKey] = _objectSpread({}, v2Selections[attributeToChange.attributeKey], {
              isHidden: false
            });
          }
        });
      });
      return _react["default"].createElement(_attributeSelector["default"], {
        ruleSet: family.ruleSet,
        authToken: authToken,
        onChange: this.props.onFamilyAttributesSelectorChange,
        showErrorAlert: true,
        onReset: onReset,
        onError: this.props.onError,
        attributeConfigurations: v2Selections
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          initialAttributeSelections = _this$props4.initialAttributeSelections,
          consumerType = _this$props4.consumerType;
      var attributeSelector = consumerType === _constants["default"].ATTRIBUTESELECTORPRICING ? this.renderWithFamily(initialAttributeSelections) : this.renderWithOutFamily();
      return _react["default"].createElement("div", {
        className: removeSeparator
      }, attributeSelector);
    }
  }]);
  return AttributesAggregator;
}(_react.PureComponent);

(0, _defineProperty2["default"])(AttributesAggregator, "propTypes", {
  authToken: _propTypes["default"].string.isRequired,
  family: function family(props, propName, componentName) {
    if ((0, _isEmpty["default"])(props[propName].sku) && (0, _isEmpty["default"])(props[propName].ruleSet)) {
      return new Error("Invalid prop '".concat(propName, "' supplied to '").concat(componentName, "'. Validation failed!, \n        One of the property of '").concat(propName, "' props 'sku' or 'ruleSet' is required in '").concat(componentName, "'."));
    }

    return null;
  },
  productAttributeKeys: _propTypes["default"].arrayOf(_propTypes["default"].string),
  onChange: _propTypes["default"].func.isRequired,
  onFamilyAttributesSelectorChange: _propTypes["default"].func.isRequired,
  onReset: _propTypes["default"].func.isRequired,
  initialAttributeSelections: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  attributeConfigurations: _propTypes["default"].shape({}),
  hiddenAttributes: _propTypes["default"].arrayOf(_propTypes["default"].string),
  showErrorModal: _propTypes["default"].bool,
  selectedSkuInFamily: _propTypes["default"].string,
  onSkuChange: _propTypes["default"].func.isRequired,
  isPivot: _propTypes["default"].bool.isRequired,
  pivotConfiguration: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  onChangePivotResponse: _propTypes["default"].func.isRequired,
  showSelectorPivotUI: _propTypes["default"].bool.isRequired,
  onError: _propTypes["default"].func.isRequired,
  consumerType: _propTypes["default"].string.isRequired
});
(0, _defineProperty2["default"])(AttributesAggregator, "defaultProps", {
  initialAttributeSelections: [],
  attributeConfigurations: {},
  hiddenAttributes: [],
  showErrorModal: false,
  pivotConfiguration: []
});
var _default = AttributesAggregator;
exports["default"] = _default;